export default __webpack_public_path__ + "static/media/NEW_Signature_Logo.ea834907.png";